<template>
    <div v-loading="loading2" class="content">
        <div>
            <h2>询问笔录</h2>
            <el-form :model="form" ref="form" :rules="rules" label-width="120px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="身份:"  required style="margin-bottom:0 !important;">
                        <el-form-item label="" prop="sf" style="width:160px;float:left;">
                            <el-input 
                                v-model="form.sf"
                                placeholder="被询问人身份"
                                clearable
                                size="small"
                                />
                        </el-form-item>
                        <el-form-item label="被询问人:" prop="xm" style="width:calc(100% - 160px);float:left;">
                            <el-input style="width:140px;"
                            v-model="form.xm"
                            placeholder="被询问人姓名"
                            clearable
                            size="small"
                            />&nbsp;
                            <el-select v-model="form.xb" placeholder="性别" size="small"  style="width:80px;">
                                <el-option
                                    v-for="dict in xbOptions"
                                    :key="dict.id"
                                    :label="dict.label"
                                    :value="dict.label"
                                    ></el-option>
                            </el-select>&nbsp;
                            <el-select v-model="form.nationals" placeholder="民族" size="small" style="width:120px;">
                                <el-option
                                    v-for="dict in mzOptions"
                                    :key="dict.id"
                                    :label="dict.nation"
                                    :value="dict.nation"
                                    ></el-option>
                            </el-select>&nbsp;
                            <el-input style="width:80px;"
                            v-model="form.nianling"
                            placeholder="年龄"
                            clearable
                            size="small"
                            /> 岁
                        </el-form-item>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号:" prop="sfzh">
                            <el-input
                            v-model="form.sfzh"
                            placeholder="请输入身份证号"
                            clearable
                            size="small" @input="getSfzh()"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="住址:" prop="zhuzhi">
                            <el-input
                            v-model="form.zhuzhi"
                            placeholder="请输入住址"
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="单位名称:" prop="dwmc">
                            <el-input
                            v-model="form.dwmc"
                            placeholder="请输入单位名称"
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="职务:" prop="zhiwu">
                            <el-input
                            v-model="form.zhiwu"
                            placeholder="请输入职务"
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系电话:" prop="lxdh">
                            <el-input
                            v-model="form.lxdh"
                            placeholder="请输入联系电话"
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12"></el-col>
                    <el-col :span="12">
                        <el-form-item label="询问机关:">
                            <el-input 
                            v-model="jcjg"
                            placeholder=""
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12"></el-col>
                    <el-col :span="24">
                        <el-form-item label="询问时间:" prop="xwsj">
                            <el-date-picker size="small"
                                v-model="form.xwsj"
                                type="date"
                                placeholder="选择日期" value-format="yyyy-MM-dd">
                            </el-date-picker>&nbsp;
                            <el-time-picker size="small" style="width:120px;"
                                placeholder="起始时间" format="HH:mm"
                                value-format="HH:mm"
                                v-model="form.xwsjstart">
                            </el-time-picker>&nbsp;至
                            <el-time-picker size="small" style="width:120px;"
                                placeholder="结束时间" format="HH:mm"
                                value-format="HH:mm"
                                v-model="form.xwsjend">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="询问地点:" prop="xwdd">
                            <el-select v-model="form.xwdd" placeholder="" size="small">
                            <el-option
                                v-for="(dict,index) in ksdzOptions"
                                :key="index"
                                :label="dict.kslxdz"
                                :value="dict.kslxdz"
                                ></el-option>
                        </el-select>&nbsp;
                        <el-input
                            v-model="form.xwdds"
                            placeholder=""
                            clearable
                            size="small" style="width:120px;"
                            />
                            室
                            <!-- <el-checkbox v-model="isXz">通过远程询问系统询问</el-checkbox> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="询问内容:" >
                            <div>
                                <span>我们是{{jcjg}}卫生执法人员</span>
                                <el-select v-model="form.zhubanren" placeholder="主办人" size="small"  style="width:100px;" @change="getZfzh(form.zhubanren,1)">
                                    <el-option
                                    v-for="(dict,index) in jdyOptions"
                                :key="index"
                                        :label="dict.xm"
                                        :value="dict.xm"
                                        ></el-option>
                                </el-select>
                                <span>、</span>
                                <el-select v-model="form.xiebanren" placeholder="协办人" size="small"  style="width:100px;" @change="getZfzh(form.xiebanren,2)">
                                    <el-option
                                    v-for="(dict,index) in jdyOptions"
                                :key="index"
                                        :label="dict.xm"
                                        :value="dict.xm"
                                        ></el-option>
                                </el-select>
                                <span>， 现场出示《{{sheng}}行政执法证》（证号：</span>
                                <el-input disabled   style="width:160px;"
                                    v-model="form.zbrzfzh"
                                    placeholder="执法证1"
                                    clearable
                                    size="small"
                                />
                                <span>、</span>
                                <el-input disabled  style="width:160px;"
                                    v-model="form.xbrzfzh"
                                    placeholder="执法证2"
                                    clearable
                                    size="small"
                                />
                                <span>），现依法对你进行询问。你应当如实回答我们的询问并协助调查，不得提供虚假证言，不得伪造、隐匿、毁灭证据，否则将承担法律责任。你有权就询问事项自行提供书面材料，有权拒绝回答与案件无关的问题，有权核对询问笔录，对笔录记载有误或者遗漏之处提出更正或者补充意见，如果你回答的内容涉及国家机密、商业秘密或者个人隐私，本机关将予以保密。同时，根据《中华人民共和国行政处罚法》的规定，你有权利陈述或申辩。对办案人员有下列情形之一的，你及你的法定代理人有权申请回避：（一）是本案的当事人或者是当事人的近亲属；（二）本人或者其近亲属和本案有利害关系的；（三）与本案当事人有其他关系，可能影响案件公正处理的；（四）是本案的证人或者鉴定人。</span>
                            </div>
                            <!--<div style="text-align:right;">
                                <el-button type="primary" size="small" @click="getTuili">推理</el-button>
                            </div>-->
                            <div>
                                <el-input v-loading="loadingTl" v-model="form.tuilineirong" type="textarea" placeholder="" rows="7" style="width:100%;" ></el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                    <!--<el-col :span="24">
                        <el-form-item label="签名方式">
                            <el-radio-group v-model="form.signs">
                                <el-radio :label="'1'">电子签名</el-radio>
                                <el-radio :label="'2'" >手工签名</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>-->
                    
                <el-col :span="24">
                <el-form-item style="text-align:center;">
                    <el-button type="primary" @click="submit('form',1)">生成询问笔录</el-button>

                    <el-button v-if="isWs" type="warning" @click="show()">预览</el-button>
                </el-form-item>
                </el-col>
                </el-row>
            </el-form>
        </div>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="询问笔录" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    props:['code','mid','pcId','xwbl','xwSf','xwText','xwShuji','jdy1','jdy2','zfzh1','zfzh2','form1'],
    data() {
        return {
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            jcjg:'',
            sheng:'',
            loading:false,
            loading2:false,
            form:{
                xwbl:1,
                sf:'',
                dwmc: '',
                xb: '',
                zhiwu: '',
                xm: '',
                nationals: '',
                sfzh: '',
                lxdh: '',
                xiangjiedao: '',
                zhuzhi: '',
                zjtype: '',
                nianling:'',
                xwsj:'',
                xwsjstart:'',
                xwsjend:'',
                zhubanren:'',
                xiebanren:'',
                zbrzfzh:'',
                xbrzfzh:'',
                xwdd:'',
                signs:'1',
                xwdds:'',
                tuilineirong:''
            },
            isXz:false,
            rules:{
                sf:[
                    { required: true, message: '被询问人身份不能为空', trigger: ['blur','change'] },
                ],
                xm:[
                    { required: true, message: '被询问人不能为空', trigger: 'blur' },
                ],
                xb:[
                    { required: true, message: '性别不能为空', trigger: 'blur' },
                ],
                nationals:[
                    { required: true, message: '民族不能为空', trigger: 'blur' },
                ],
                nianling:[
                    { required: true, message: '年龄不能为空', trigger: 'blur' },
                ],
                sfzh:[
                    { required: true, message: '身份证号不能为空', trigger: 'blur' },
                    {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '证件号码格式有误！',
                        trigger: 'blur'
                    }
                ],
                zhuzhi:[
                    { required: true, message: '住址不能为空', trigger: 'blur' },
                ],
                dwmc:[
                    { required: true, message: '单位名称不能为空', trigger: 'blur' },
                ],
                zhiwu:[
                    { required: true, message: '职务不能为空', trigger: ['blur','change'] },
                ],
                lxdh:[
                    { required: true, message: '联系电话不能为空', trigger: 'blur' },
                ],
                xwdd:[
                    { required: true, message: '询问地点不能为空', trigger: 'blur' },
                ],
            },
            xbOptions:[
                {id:1,label:'男'},
                {id:2,label:'女'}
            ],
            mzOptions:[],
            zwOptions:[],
            xwblOptions:[],
            blOptions:[],
            sfOptions:[
                {value:'（法定代表人/负责人/经营者）本人',label:'（法定代表人/负责人/经营者）本人',bm:0},
                {value:'委托代理人',label:'委托代理人',bm:1},
                {value:'案件其他相关人员',label:'案件其他相关人员',bm:2}
            ],
            jdyOptions: [], 
            ksdzOptions:[],
            fzrxx:[],
            jdyxx:[],
            isBtn:false,
            blLsh:'',
            blname:'',
 
            bcfs:'',
            wsUrl:'',
            dwXx:{},

            isWs:false,
            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            blIndex:0,
            baseUrl:'',
            loadingTl:false,
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.jcjg = user.jcjg
        this.sheng = user.sheng
        this.baseUrl = user.baseUrl
        console.log(user)
    },
    mounted() {        
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getminzu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.mzOptions =  res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        }) 
        console.log(this.xwSf,this.xwText,this.xwShuji,this.xwKey,400)       
        this.getList()
    },
    methods: {
        getTuili(){
            this.loadingTl = true
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/otherInferences`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    mid:this.mid,
                    lsh:this.pcId,
                    templateName:this.code
                }
            })
            .then(response => {
                console.log(response.data,1081);
                if(response.data.code == 0 && response.data.data){
                    let str = response.data.data.answer || '';
                    this.$set(this.form,'tuilineirong',str)
                }else{
                    this.$message.error(response.data.msg);
                }
                this.loadingTl = false
            })
            .catch(error => {
                this.loadingTl = false
                this.$message.error('推理失败！'|| error);
                console.error('There was an error!', error);
            });
        },
        getList(){
            this.isWs = false
            this.wsUrl = ''
            this.getTContact()
            this.getjdylist()
            console.log(this.xwShuji,430)
            if(this.xwShuji && this.xwShuji.xwbl_lsh){
                this.blLsh = this.xwShuji.xwbl_lsh
                this.form = {
                    sf:this.xwShuji.interviewee_identity,
                    ...this.xwShuji,
                }
                this.isWs = true
                this.wsUrl = this.xwShuji.url
            }else{
                if(this.jdy1){
                    this.$set(this.form,'zhubanren',this.jdy1)
                    this.$set(this.form,'zbrzfzh',this.zfzh1)
                }
                if(this.jdy2){
                    this.$set(this.form,'xiebanren',this.jdy2)
                    this.$set(this.form,'xbrzfzh',this.zfzh2)
                }
                if(this.form1){
                    console.log(this.form1,434)
                    this.$set(this.form,'xm',this.form1.fr || '')
                    this.$set(this.form,'sfzh',this.form1.sfzh || '')
                    this.$set(this.form,'zhiwu',this.form1.frzw || '')
                    this.$set(this.form,'xb',this.form1.frxb || '')
                    this.$set(this.form,'nationals',this.form1.nation || '')
                    this.$set(this.form,'lxdh',this.form1.sj1 || '')
                    this.$set(this.form,'dwmc',this.form1.dwmc || '')
                    this.$set(this.form,'zhuzhi',this.form1.dwdz || '')
                    if(this.form1.sfzh){
                        this.getSfzh()
                    }
                }
                let date = new Date()
                let rq = this.getDate(date,'yyyy-MM-dd')
                let rq1 =  this.getDate(date,'hh:mm')
                let rq2 =  this.getDate(date,'hh:mm')
                this.$set(this.form,'xwsj',rq)
                this.$set(this.form,'xwsjstart',rq1)
                this.$set(this.form,'xwsjend',rq2)
                this.$set(this.form,'sf',this.xwSf)
                this.$set(this.form,'tuilineirong',this.xwText)
            }
        },
        getTContact() {
            this.ksdzOptions = []
            axios({
                method: 'post',
                url: this.baseUrl+`/login/GetTContact`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid:this.cmid,
                }
            })
            .then(response => {
                console.log(response.data);
                this.c_org = response.data.data.c_org || ''
                this.ksdzOptions.push({kslxdz:response.data.data.c_address})
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        getjdylist() {
            console.log(this.cmid)
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/lawEnforcer`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid:this.cmid
                }
            })
            .then(response => {
                this.jdyOptions = response.data.data
            })
            .catch(error => {
                this.$message.error('获取监督员数据失败！');
                console.error('There was an error!', error);
            });
        },
        getZfzh(jdy,val){
            console.log(jdy,val,this.jdyOptions)
            let arr = this.jdyOptions.filter(item => {
                return item.xm === jdy
            })
            console.log(arr)
            if(val == 1){
                this.$set(this.form,'zbrzfzh',arr[0].zfzh)
            }else if(val == 2){
                this.$set(this.form,'xbrzfzh',arr[0].zfzh)
            }
        },
        // 计算年龄
        getAge(idNumber) {
            // 提取年月日
            let year, month, day;

            if (idNumber.length === 18) {
                year = idNumber.substring(6, 10);
                month = idNumber.substring(10, 12);
                day = idNumber.substring(12, 14);
            } else if (idNumber.length === 15) {
                // 15位身份证号（19xx开头）
                year = "19" + idNumber.substring(6, 8);
                month = idNumber.substring(8, 10);
                day = idNumber.substring(10, 12);
            } else {
                return NaN; // 不合法身份证号
            }

            const birthDateStr = `${year}/${month}/${day}`;
            const birthTime = new Date(birthDateStr).getTime();
            const nowTime = new Date().getTime();

            // 每年毫秒数（365天）
            const yearMs = 365 * 24 * 60 * 60 * 1000;

            // 计算年龄
            const age = Math.floor((nowTime - birthTime) / yearMs);

            return age >= 0 ? age : NaN;
        },
        getSfzh(){
            if(this.form.sfzh){
                console.log(this.form.sfzh)
                let nl = this.getAge(this.form.sfzh+'');
                console.log(nl)
                if(!Number.isNaN(nl)){
                    console.log(nl)
                    this.form.nianling = Number(nl)
                }
            }
        },
        testid(id) {
            // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
            var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
            //号码规则校验
            if(!format.test(id)){
            return {'status':0,'msg':'身份证号码不合规'};
            }
            //区位码校验
            //出生年月日校验  前正则限制起始年份为1900;
            var year = id.substr(6,4),//身份证年
            month = id.substr(10,2),//身份证月
            date = id.substr(12,2),//身份证日
            time = Date.parse(month+'-'+date+'-'+year),//身份证日期时间戳date
            now_time = Date.parse(new Date()),//当前时间戳
            dates = (new Date(year,month,0)).getDate();//身份证当月天数
            if(time>now_time||date>dates){
            return {'status':0,'msg':'出生日期不合规'}
            }
            //校验码判断
            var c = new Array(7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2);  //系数
            var b = new Array('1','0','X','9','8','7','6','5','4','3','2'); //校验码对照表
            var id_array = id.split("");
            var sum = 0;
            for(var k=0;k<17;k++){
            sum+=parseInt(id_array[k])*parseInt(c[k]);
            }
            if(id_array[17].toUpperCase() != b[sum%11].toUpperCase()){
            return {'status':0,'msg':'身份证校验码不合规'}
            }
            return {'status':1,'msg':'校验通过'}
        },

        submit(form,val){
            if(val == 1){
                if(this.form.xm){
                    if (this.form.xm.indexOf('@') != -1 || this.form.xm.indexOf('*') != -1) {
                        this.$message.error('被询问人不能含有“@”、“*”字符，如不知被询问人姓名，请用“某某”替代。');
                        return false;
                    }
                }else{
                    this.$message.error('被询问人不能为空')
                    return false;
                }
                if(this.form.zhuzhi){
                    if (this.form.zhuzhi.indexOf('@') != -1 || this.form.zhuzhi.indexOf('*') != -1) {
                        this.$message.error('住址不能含有“@”、“*”字符。');
                        return false;
                    }
                }else{
                    this.$message.error('住址不能为空')
                    return false;
                }
                if(!this.form.sf){
                    this.$message.error('被询问人身份不能为空')
                    return false;
                }
                if(!this.form.xb){
                    this.$message.error('性别不能为空')
                    return false;
                }
                if(!this.form.nationals){
                    this.$message.error('民族不能为空')
                    return false;
                }
                if(!this.form.nianling){
                    this.$message.error('年龄不能为空')
                    return false;
                }
                if(!this.form.sfzh){
                    this.$message.error('身份证号不能为空')
                    return false;
                }else{
                    let reg=/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/
                    if(!reg.test(this.form.sfzh)){
                        this.$message.error('身份证号格式有误')
                        return false;
                    }
                }
                if(!this.form.dwmc){
                    this.$message.error('单位名称不能为空')
                    return false;
                }
                if(!this.form.zhiwu){
                    this.$message.error('职务不能为空')
                    return false;
                }
                if(!this.form.lxdh){
                    this.$message.error('联系电话不能为空')
                    return false;
                }
                if(!this.form.xwdd){
                    this.$message.error('询问地点不能为空')
                    return false;
                }
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        this.submit1(val)
                    }else{
                        return false
                    }
                })
            }else{
                this.submit1(val)
            }
        },

        async submit1(val){
            this.loading = true
            console.log(this.blLsh,this.form,1375) 
            let obj = {
                lsh: this.pcId,
                wsName:'询问笔录',
                id: this.pcId,
                xwblLsh:this.blLsh,
                intervieweeIdentity:this.form.sf,
                name:this.form.xm,
                xb:this.form.xb,
                national:this.form.nationals,
                nianling:this.form.nianling,
                sfzh:this.form.sfzh,
                zhuzhi:this.form.zhuzhi,
                dwmc:this.form.dwmc,
                zhiwu:this.form.zhiwu,
                lxdh:this.form.lxdh,
                xwsj:this.getDate(this.form.xwsj,'yyyy-MM-dd'),
                xwsjstart:this.form.xwsjstart,
                xwsjend:this.form.xwsjend,
                xwdd:this.form.xwdd,
                xwdds:this.form.xwdds,
                zhubanren:this.form.zhubanren,
                xiebanren:this.form.xiebanren,
                zbrzfzh:this.form.zbrzfzh,
                xbrzfzh:this.form.xbrzfzh,
                signs:this.form.signs,
                tuilineirong:this.form.tuilineirong,
                createTime:this.getDate(new Date()),                                                     
                cmid:this.cmid,
                xm:this.xm,
                dm:this.dm,
                shi:this.shi,
                xianqu:this.xianqu,
                jcjg:this.jcjg
            }
            console.log(obj,1385)
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/makeXwblWenshu`,
                data:obj,
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                console.log(res,809)
                this.loading = false
                if(res.data.code == 0 && res.data.data){
                    this.wsUrl = res.data.data.url   
                    this.blLsh = res.data.data.xcblLsh                 
                    this.isWs = true                        
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.show()
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }else{
                        this.$message({
                            message: '保存失败，请重新填写',
                            type: 'error'
                        }); 
                    }
                }
            }).catch(res => {
                this.loading = false
            })
        },
        renew(e){
            this.$forceUpdate()
        },
        show(){
            if(this.wsUrl){
                let n = this.xwKey || '1'
                let url = this.$router.resolve({
                    path:'/pdf2',
                    query:{
                        wsname:'xunwenbilu'+n,
                        ws:encodeURIComponent(this.wsUrl) // 手动 encode 一次
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        }
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.tips{ min-height: 500px; text-align: center;}
.tips p{margin:100px 50px 30px;line-height: 80px; font-size: 24px;}
.news{border: solid 1px #dcdfe6; padding: 10px; border-radius: 3px; margin-top:10px;}
.news li{margin-bottom: 10px;}
.mb.el-form-item {
    margin-bottom: 5px !important;
}
  .el-timeline-item__timestamp {
    color: #2819f9;
    line-height: 1;
    font-size: 16px;
  }

  .content {
    padding: 10px 0;

  }
  .content .el-collapse-item {
    border: 1px solid #DCDFE5;
    margin-bottom: 20px;
  }

  .content .el-collapse-item__header {
    background: #eff2f9;
    padding: 0 20px;
    border-bottom: 1px solid #DCDFE5;
  }

  /* #content1 .el-collapse-item__content {
    padding: 20px 0 0 30px;
  } */

  .btn_group .el-form-item__content {
    margin-left: 20px !important;
  }

  .text_item .el-textarea__inner, .text_item .el-textarea__inner:focus {
    /* border:none; */
    margin-bottom: -10PX;
  }

  .tableForm {

  }

  .el-input.is-disabled .el-input__inner {
    background-color: white;
    border-color: #dfe4ed;
    color: #C0C4CC;
    cursor: not-allowed;
  }

  .el-textarea.is-disabled .el-textarea__inner {
    background-color: white;
    border-color: #dfe4ed;
    color: #C0C4CC;
    cursor: not-allowed;
  }

  .el-range-editor.is-disabled input {
    background-color: white;
    color: #C0C4CC;
    cursor: not-allowed;
  }

  .content >>> .el-input.is-disabled .el-input__inner { color: #333;}
.content >>> .el-form-item {
    margin-bottom: 12px !important;
}
.content >>> .el-loading-spinner{top: 40px !important;}
</style>